/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/Setup',[
    'jquery',
    'global/Logger',
    './Navigation',
    'plugins/affix',
    'plugins/jquery.truncator',
    'plugins/collapse',
    'plugins/dismissable'
], function ($, Logger, Navigation, affix, truncator, collapse) {
    'use strict';

    var other$ = jQuery;

    Logger.debug('Setting up JS Plugins...');

    $(function () {
        // Workaround regarding targetblank vulnerability, for more details see: https://dev.to/ben/the-targetblank-vulnerability-by-example
        $('a[target=_blank], a[target=new]').attr('rel', 'noopener noreferrer');

        // functionality for hidden/expandable content
        $('.siteBody').on('click', '.expandable-trigger', function (e) {
            var trigger = $(e.currentTarget);
            trigger.find('.icon-plus-circle').toggleClass('icon-minus-circle');
            trigger.next('.expandable').toggleClass('expanded');
        });

        // sticky recently viewed (for large screens)
        other$('#recently-viewed').affix({
            offset: {
                top: function () {
                    return (this.top = $('#recently-viewed').offset().top - 70);
                },
                bottom: function () {
                    return (this.bottom = $('.footer').outerHeight(true) + 30);
                }
            }
        });

        other$('#sticky-nav').affix({
            offset: {
                top: function () {
                    return (this.top = $('#sticky-nav').offset().top - $('.roc-navbar-impersonation').outerHeight(true));
                }
            }
        }).on('affix.bs.affix', function(e) {
            var toolbar = $('.roc-navbar-impersonation');

            if ((toolbar.length > 0) && window.matchMedia("(min-width: 1100px)").matches) {
                var fixedOffset = toolbar.outerHeight(true);
                var stickyNav = $(e.currentTarget); 

                stickyNav.css('top', fixedOffset);
                stickyNav.on('affix-top.bs.affix', function(e) {
                    if (toolbar.length > 0) {
                        stickyNav.css('top', '0')
                    };
                });
            };
        });

        // Close add to favorites menu when outside click.
        $(document).click(function (event) {
            var clickover = $(event.target);
            var _opened = $(".roc-addToCartFavoritesMenu").hasClass("in");
            var insideDropdown = $('.roc-addToCartFavoritesMenu').find(clickover).length == 1;

            if (_opened === true && !clickover.hasClass("collapse") && !insideDropdown) {
                $("#collapseExample").collapse('hide')
            }
        });

        // use 'data-hijax' to prevent navigation to href
        $('body').on('click', '[data-hijax="true"]', function (e) {
            e.preventDefault();
        });
        
        // set up collapse extensions
        $('body').on('show.bs.collapse', '[data-auto-collapse="true"]', function(e){
            $('body').on('click', collapseAutoClose);
        }).on('hidden.bs.collapse', '.collapse', function(e){
            $('body').off('click', collapseAutoClose);
        });
        
        function collapseAutoClose(e) {
            if ($(e.target).closest('[data-auto-collapse="true"]').length === 0) {
                $('[data-auto-collapse="true"].in').collapse('hide');
            };
        };

        $('#favorites-toolbar-content').on('show.bs.collapse', function (e) {
            var toolbarTrigger = $('.roc-favoritesToolbar .roc-moduleHeader .btnText'),
                toolbarTriggerText = toolbarTrigger.find('.changeText');
            toolbarTriggerText.text(toolbarTrigger.data('textExpanded'));
        }).on('hidden.bs.collapse', function (e) {
            var toolbarTrigger = $('.roc-favoritesToolbar .roc-moduleHeader .btnText'),
                toolbarTriggerText = toolbarTrigger.find('.changeText');
            toolbarTriggerText.text(toolbarTrigger.data('textCollapsed'));
        });

        $('.truncate').truncate({
            max_length: 400,
            more: 'read more',
            less: 'read less'
        });
    });

    // This is required to fix an issue in earlier versions of Windows Phone 8
    // http://timkadlec.com/2013/01/windows-phone-8-and-device-width/
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement('style');
        msViewportStyle.appendChild(
          document.createTextNode(
            '@-ms-viewport{width:auto!important}'
          )
        );
        document.querySelector('head').appendChild(msViewportStyle);
    }

    //Fix for console errors in IE when resizing window on checkout https://stackoverflow.com/questions/21261498/google-maps-in-ie11-gives-unspecified-error
    HTMLElement.prototype._getBoundingClientRect = HTMLElement.prototype.getBoundingClientRect;
    HTMLElement.prototype.getBoundingClientRect = function () {
        try {
            return this._getBoundingClientRect();
        } catch (e) {
            return { top: this.offsetTop, left: this.offsetLeft };
        }
    }

    var Setup = {};

    return Setup;
});

